import React from 'react';
import makeStyles from '@material-ui/styles/makeStyles';
import { ReactComponent as SuccessSVG } from '../../../assets/images/icon-success-check.svg';
import { ReactComponent as ErrorSVG } from '../../../assets/images/icon-error-circle.svg';

const useStyles = makeStyles((theme) => ({
    root: {
        textAlign: 'center',
        '& >p': {
            color: '#212121',
            fontSize: '1.25rem',
            fontWeight: 600,
        },
    },
    buttonsDiv: {
        marginTop: '2.5rem',
        '& >div:first-child': {
            background: '#F3F4F9',
            borderRadius: '8px',
            padding: '0.9375rem 1.5625rem',
            color: '#212121',
            fontSize: '1rem',
            fontWeight: 600,
            margin: '0 auto 1rem auto',
            width: 'fit-content',
            '&:hover': {
                cursor: 'pointer',
            },
        },
        '& >div:nth-child(2)': {
            color: '#737FA4',
            fontSize: '1rem',
            fontWeight: 400,
            '&:hover': {
                cursor: 'pointer',
            },
        },
    },
}));

export interface IMessageModal {
    status: 'success' | 'error';
    message: string;
    ButtonOneText?: string;
    ButtonTwoText?: string;
    onButtonOneClick?: () => void;
    onButtonTwoClick?: () => void;
}

const MessageModal = ({
    status,
    message,
    ButtonOneText,
    ButtonTwoText,
    onButtonOneClick,
    onButtonTwoClick,
}: IMessageModal) => {
    const classes = useStyles();

    function renderButtons() {
        let buttons = [];

        if (ButtonOneText) {
            buttons.push(<div onClick={onButtonOneClick}>{ButtonOneText}</div>);
        }
        if (ButtonTwoText) {
            buttons.push(<div onClick={onButtonTwoClick}>{ButtonTwoText}</div>);
        }

        return buttons;
    }

    return (
        <div className={classes.root}>
            {status === 'success' ? (
                <SuccessSVG height="3.125rem" width="3.125rem" />
            ) : (
                <ErrorSVG height="3.125rem" width="3.125rem" />
            )}
            <p>{message}</p>
            <div className={classes.buttonsDiv}>{renderButtons()}</div>
        </div>
    );
};

export default MessageModal;
